(function($, Drupal, once) {

  Drupal.behaviors.retain_main = {
    attach: function (context, settings) {

      // Simple jquery method that ensures an action is performed only once for an element
      $.fn.onlyOnce = function(actionName) {
        var attrName = 'data-only-once-' + actionName;
        var proceed = true;

        this.each(function() {
          var $this = $(this);

          if ($this.attr(attrName)) {
            proceed = false;
            return false; // Break out of the each loop
          }

          $this.attr(attrName, true);
        });

        return proceed ? this : $(); // Return the element if the attribute doesn't exist, else return an empty jQuery object
      };

      $('header.header-mega-menu ul.menu li.menu-item').mouseenter(function(){
        let container = $(this).find('.menu_link_content .container');
        if (container.length && container.children().length === 0) return;
        let header = $(this).closest('header');
        header.addClass('mega-menu-open');
      });

      $('header.header-mega-menu ul.menu li.menu-item').mouseleave(function(){
        let header = $(this).closest('header');
        header.removeClass('mega-menu-open');
      });

      $(window).on('scroll', function() {
        if ($(window).scrollTop() > 50) {
          $('body').addClass('user-scrolled');
        } else {
          $('body').removeClass('user-scrolled');
        }
      });

      let ctaElement = $('.fixed-sidebar');
      let headerHeight = $('header').outerHeight() + 100; // Replace '.header' with the selector for your header element
      ctaElement.css('top', headerHeight + 'px');

      function articleBackgroundImage() {
        var articleBannerImage = $('.article-banner-image');

        if (articleBannerImage.length) {
          var image = articleBannerImage.attr('data-background-image');

          if ($(window).width() > 1200) {
            articleBannerImage.attr('style', 'background-image: url('+image+')');
          } else {
            articleBannerImage.attr('style', '');
          }
        }
      }
      articleBackgroundImage();

      $('input[name="phone"]').change(function(){
        var cleanedPhone = $(this).val().replace(/ /g, '');;
        $(this).val(cleanedPhone);
      });

      $('.header-mobile--bars a').click(function(){
        console.log('mobile header toggled')
        let body = $('body')

        if (body.hasClass('mobile-nav-open')) {
          body.removeClass('mobile-nav-open');
        } else {
          body.addClass('mobile-nav-open');
        }

        return false;
      });

      $('form[id^=retain-services-email-download-link-]').click(function() {
        $(this).parents('.paragraph').find('.result_message').empty();
      });

      /* Tabbed Content */
      $('.tabbed-content ul.content-menu li a').click(function(){
        var contents = $(this).closest('.tabbed-content').find('.contents');
        var ul = $(this).closest('ul');
        var li = $(this).parent('li');

        if (!li.hasClass('active')) {
          ul.find('li').removeClass('active');
          li.addClass('active');

          var index = li.index() + 1;

          contents.find('.content-item.active').removeClass('active');
          contents.find('.content-item:nth-child('+index+')').addClass('active');

          // Scroll down on mobile devices
          if ($(window).width() < 992) {
            $([document.documentElement, document.body]).animate({
              scrollTop: $('.tabbed-content .content-menu li:last-child').offset().top
            }, 500);
          }
        }

        return false;
      });

      /* Pricing - mobile */
      $('.pricing-mobile a[data-toggle="features"]').click(function(){
        $(this).closest('.row').hide();
        $(this).closest('.plan').find('.plan-features').show();

        return false;
      });

      /* Pricing feature toggle - desktop */
      $('.pricing-desktop .all-features-link a').click(function(){
        var features = $(this).closest('.pricing-desktop').find('.all-features');

        if (features.hasClass('active')) {
          features.removeClass('active');
          $(this).removeClass('active');
        } else {
          features.addClass('active');
          $(this).addClass('active');
        }

        return false;
      });

      // Article a banner background image
      $(window).resize(function(){
        articleBackgroundImage();
      });

      function setHeightOfTextBlockLeftImageRight() {
        var windowWidth = $(window).width();
        var textBlockLeft = $('.text-block-left-overlapped-image-right');
        var image = textBlockLeft.find('.image');
        var text = textBlockLeft.find('.text-box-container');
        var innerHeight = 0;

        innerHeight = image.height() + text.height();

        textBlockLeft.find('.inner').css('min-height', innerHeight + 'px');
      }
      setHeightOfTextBlockLeftImageRight();

      $(window).resize(function(){
        setHeightOfTextBlockLeftImageRight();
      });

      // Hide alerts when clicking close
      $('.alert button.close').click(function() {
        $(this).closest('.alert').fadeOut();
      });

      // FAQ accordion functionality
      $('.paragraph-faq .question a').click(function(){
        var faq = $(this).closest('.paragraph-faq');

        if (faq.hasClass('open')) {
          // Close question
          faq.removeClass('open');
        } else {
          // Open question
          faq.addClass('open');
        }

        return false;
      });

      // Interactive features functionality
      $('.interactive-features .interactive-menu-item a').click(function(){
        var width = $(window).width();

        if (width > 1200) {
          $(this).closest('.interactive-features').find('.active').removeClass('active');
          $(this).closest('.interactive-menu-item').addClass('active');
          var index = $(this).closest('.interactive-menu').find('.active').index() + 1;
          $(this).closest('.interactive-features').find('.interactive-feature-item:nth-child('+index+')').addClass('active');
        }

        return false;
      });

      $('.customer-story-teaser').click(function(e){
        var anchor = $(this).find('.customer-story-teaser__title a').first();

        if (anchor.length) {
          var href = anchor.attr('href');
          if (href) {
            window.location.href = href;
          }
        }

        e.preventDefault();
        return false;
      });

      $('.article-teaser').click(function(e){
        if ($(e.target).closest('a').length) {
          return;
        }

        var anchor = $(this).find('.article-teaser__title a').first();

        if (anchor.length) {
          var href = anchor.attr('href');
          if (href) {
            window.location.href = href;
          }
        }

        e.preventDefault();
        return false;
      });
    }
  };

  $(document).ready(function(){
    let $slider = $(".logo-carousel__container").first();
    if ($slider.length === 0)
      return;

    if ($slider.hasClass('initialised'))
      return;

    $slider.addClass('initialised');

    let $sliderContainer = $slider.parent();
    let sizeImage = 300;
    let containerWidth = $sliderContainer.width();
    let items = $slider.children('.logo-carousel__container__item').length;
    let itemsWidth = items * sizeImage;

    // Clone items to fill the empty view
    while (itemsWidth < containerWidth * 2) {
      // Clone enough items to cover at least twice the container width
      $slider.children('.logo-carousel__container__item').clone().appendTo($slider);
      items = $slider.children('.logo-carousel__container__item').length;
      itemsWidth = items * sizeImage;
    }

    $slider.css("width", itemsWidth);

    let rotating = true;
    let sliderspeed = 30; // Adjust the speed as needed
    let seeitems;
    if (!seeitems) {
      seeitems = setInterval(rotateSlider, sliderspeed);
    }

    $(document).on(
      {
        mouseenter: function () {
          rotating = false; // turn off rotation when hovering
        },
        mouseleave: function () {
          rotating = true;
        },
      },
      ".logo-carousel__container"
    );

    function rotateSlider() {
      if (rotating) {
        $slider.css("margin-left", function (i, value) {
          let marginLeft = parseInt(value, 10) || 0;
          marginLeft -= 1; // Adjust the speed of the animation by changing the decrement value
          if (Math.abs(marginLeft) >= sizeImage) {
            $slider.children('.logo-carousel__container__item').first().appendTo($slider);
            marginLeft += sizeImage;
          }
          return marginLeft + "px";
        });
      }
    }
  });

  $(document).ready(function(){
    const playbackRate = 1;
    const video = $('.hero video').first();
    if (video.length > 0) {
      video.on('play', function() {
        this.playbackRate = playbackRate
        console.log('setting playback speed to ' + playbackRate);
      });
    }
  });

})(jQuery, Drupal, once)




